import { ReactComponent as ClearskyDay } from "./svg/clearsky_day.svg"
import { ReactComponent as ClearskyNight } from "./svg/clearsky_night.svg"
import { ReactComponent as ClearskyPolartwilight } from "./svg/clearsky_polartwilight.svg"
import { ReactComponent as Cloudy } from "./svg/cloudy.svg"
import { ReactComponent as FairDay } from "./svg/fair_day.svg"
import { ReactComponent as FairNight } from "./svg/fair_night.svg"
import { ReactComponent as FairPolartwilight } from "./svg/fair_polartwilight.svg"
import { ReactComponent as Fog } from "./svg/fog.svg"
import { ReactComponent as Heavyrain } from "./svg/heavyrain.svg"
import { ReactComponent as Heavyrainandthunder } from "./svg/heavyrainandthunder.svg"
import { ReactComponent as HeavyrainshowersandthunderDay } from "./svg/heavyrainshowersandthunder_day.svg"
import { ReactComponent as HeavyrainshowersandthunderNight } from "./svg/heavyrainshowersandthunder_night.svg"
import { ReactComponent as HeavyrainshowersandthunderPolartwilight } from "./svg/heavyrainshowersandthunder_polartwilight.svg"
import { ReactComponent as HeavyrainshowersDay } from "./svg/heavyrainshowers_day.svg"
import { ReactComponent as HeavyrainshowersNight } from "./svg/heavyrainshowers_night.svg"
import { ReactComponent as HeavyrainshowersPolartwilight } from "./svg/heavyrainshowers_polartwilight.svg"
import { ReactComponent as Heavysleet } from "./svg/heavysleet.svg"
import { ReactComponent as Heavysleetandthunder } from "./svg/heavysleetandthunder.svg"
import { ReactComponent as HeavysleetshowersandthunderDay } from "./svg/heavysleetshowersandthunder_day.svg"
import { ReactComponent as HeavysleetshowersandthunderNight } from "./svg/heavysleetshowersandthunder_night.svg"
import { ReactComponent as HeavysleetshowersandthunderPolartwilight } from "./svg/heavysleetshowersandthunder_polartwilight.svg"
import { ReactComponent as HeavysleetshowersDay } from "./svg/heavysleetshowers_day.svg"
import { ReactComponent as HeavysleetshowersNight } from "./svg/heavysleetshowers_night.svg"
import { ReactComponent as HeavysleetshowersPolartwilight } from "./svg/heavysleetshowers_polartwilight.svg"
import { ReactComponent as Heavysnow } from "./svg/heavysnow.svg"
import { ReactComponent as Heavysnowandthunder } from "./svg/heavysnowandthunder.svg"
import { ReactComponent as HeavysnowshowersandthunderDay } from "./svg/heavysnowshowersandthunder_day.svg"
import { ReactComponent as HeavysnowshowersandthunderNight } from "./svg/heavysnowshowersandthunder_night.svg"
import { ReactComponent as HeavysnowshowersandthunderPolartwilight } from "./svg/heavysnowshowersandthunder_polartwilight.svg"
import { ReactComponent as HeavysnowshowersDay } from "./svg/heavysnowshowers_day.svg"
import { ReactComponent as HeavysnowshowersNight } from "./svg/heavysnowshowers_night.svg"
import { ReactComponent as HeavysnowshowersPolartwilight } from "./svg/heavysnowshowers_polartwilight.svg"
import { ReactComponent as Lightrain } from "./svg/lightrain.svg"
import { ReactComponent as Lightrainandthunder } from "./svg/lightrainandthunder.svg"
import { ReactComponent as LightrainshowersandthunderDay } from "./svg/lightrainshowersandthunder_day.svg"
import { ReactComponent as LightrainshowersandthunderNight } from "./svg/lightrainshowersandthunder_night.svg"
import { ReactComponent as LightrainshowersandthunderPolartwilight } from "./svg/lightrainshowersandthunder_polartwilight.svg"
import { ReactComponent as LightrainshowersDay } from "./svg/lightrainshowers_day.svg"
import { ReactComponent as LightrainshowersNight } from "./svg/lightrainshowers_night.svg"
import { ReactComponent as LightrainshowersPolartwilight } from "./svg/lightrainshowers_polartwilight.svg"
import { ReactComponent as Lightsleet } from "./svg/lightsleet.svg"
import { ReactComponent as Lightsleetandthunder } from "./svg/lightsleetandthunder.svg"
import { ReactComponent as LightsleetshowersDay } from "./svg/lightsleetshowers_day.svg"
import { ReactComponent as LightsleetshowersNight } from "./svg/lightsleetshowers_night.svg"
import { ReactComponent as LightsleetshowersPolartwilight } from "./svg/lightsleetshowers_polartwilight.svg"
import { ReactComponent as Lightsnow } from "./svg/lightsnow.svg"
import { ReactComponent as Lightsnowandthunder } from "./svg/lightsnowandthunder.svg"
import { ReactComponent as LightsnowshowersDay } from "./svg/lightsnowshowers_day.svg"
import { ReactComponent as LightsnowshowersNight } from "./svg/lightsnowshowers_night.svg"
import { ReactComponent as LightsnowshowersPolartwilight } from "./svg/lightsnowshowers_polartwilight.svg"
import { ReactComponent as LightssleetshowersandthunderDay } from "./svg/lightssleetshowersandthunder_day.svg"
import { ReactComponent as LightssleetshowersandthunderNight } from "./svg/lightssleetshowersandthunder_night.svg"
import { ReactComponent as LightssleetshowersandthunderPolartwilight } from "./svg/lightssleetshowersandthunder_polartwilight.svg"
import { ReactComponent as LightssnowshowersandthunderDay } from "./svg/lightssnowshowersandthunder_day.svg"
import { ReactComponent as LightssnowshowersandthunderNight } from "./svg/lightssnowshowersandthunder_night.svg"
import { ReactComponent as LightssnowshowersandthunderPolartwilight } from "./svg/lightssnowshowersandthunder_polartwilight.svg"
import { ReactComponent as PartlycloudyDay } from "./svg/partlycloudy_day.svg"
import { ReactComponent as PartlycloudyNight } from "./svg/partlycloudy_night.svg"
import { ReactComponent as PartlycloudyPolartwilight } from "./svg/partlycloudy_polartwilight.svg"
import { ReactComponent as Rain } from "./svg/rain.svg"
import { ReactComponent as Rainandthunder } from "./svg/rainandthunder.svg"
import { ReactComponent as RainshowersandthunderDay } from "./svg/rainshowersandthunder_day.svg"
import { ReactComponent as RainshowersandthunderNight } from "./svg/rainshowersandthunder_night.svg"
import { ReactComponent as RainshowersandthunderPolartwilight } from "./svg/rainshowersandthunder_polartwilight.svg"
import { ReactComponent as RainshowersDay } from "./svg/rainshowers_day.svg"
import { ReactComponent as RainshowersNight } from "./svg/rainshowers_night.svg"
import { ReactComponent as RainshowersPolartwilight } from "./svg/rainshowers_polartwilight.svg"
import { ReactComponent as Sleet } from "./svg/sleet.svg"
import { ReactComponent as Sleetandthunder } from "./svg/sleetandthunder.svg"
import { ReactComponent as SleetshowersandthunderDay } from "./svg/sleetshowersandthunder_day.svg"
import { ReactComponent as SleetshowersandthunderNight } from "./svg/sleetshowersandthunder_night.svg"
import { ReactComponent as SleetshowersandthunderPolartwilight } from "./svg/sleetshowersandthunder_polartwilight.svg"
import { ReactComponent as SleetshowersDay } from "./svg/sleetshowers_day.svg"
import { ReactComponent as SleetshowersNight } from "./svg/sleetshowers_night.svg"
import { ReactComponent as SleetshowersPolartwilight } from "./svg/sleetshowers_polartwilight.svg"
import { ReactComponent as Snow } from "./svg/snow.svg"
import { ReactComponent as Snowandthunder } from "./svg/snowandthunder.svg"
import { ReactComponent as SnowshowersandthunderDay } from "./svg/snowshowersandthunder_day.svg"
import { ReactComponent as SnowshowersandthunderNight } from "./svg/snowshowersandthunder_night.svg"
import { ReactComponent as SnowshowersandthunderPolartwilight } from "./svg/snowshowersandthunder_polartwilight.svg"
import { ReactComponent as SnowshowersDay } from "./svg/snowshowers_day.svg"
import { ReactComponent as SnowshowersNight } from "./svg/snowshowers_night.svg"
import { ReactComponent as SnowshowersPolartwilight } from "./svg/snowshowers_polartwilight.svg"

const WeatherSVGData = [
	{
		clearsky_day: <ClearskyDay />,
		clearsky_night: <ClearskyNight />,
		clearsky_polartwilight: <ClearskyPolartwilight />,
		cloudy: <Cloudy />,
		fair_day: <FairDay />,
		fair_night: <FairNight />,
		fair_polartwilight: <FairPolartwilight />,
		fog: <Fog />,
		heavyrain: <Heavyrain />,
		heavyrainandthunder: <Heavyrainandthunder />,
		heavyrainshowersandthunder_day: <HeavyrainshowersandthunderDay />,
		heavyrainshowersandthunder_night: <HeavyrainshowersandthunderNight />,
		heavyrainshowersandthunder_polartwilight: <HeavyrainshowersandthunderPolartwilight />,
		heavyrainshowers_day: <HeavyrainshowersDay />,
		heavyrainshowers_night: <HeavyrainshowersNight />,
		heavyrainshowers_polartwilight: <HeavyrainshowersPolartwilight />,
		heavysleet: <Heavysleet />,
		heavysleetandthunder: <Heavysleetandthunder />,
		heavysleetshowersandthunder_day: <HeavysleetshowersandthunderDay />,
		heavysleetshowersandthunder_night: <HeavysleetshowersandthunderNight />,
		heavysleetshowersandthunder_polartwilight: <HeavysleetshowersandthunderPolartwilight />,
		heavysleetshowers_day: <HeavysleetshowersDay />,
		heavysleetshowers_night: <HeavysleetshowersNight />,
		heavysleetshowers_polartwilight: <HeavysleetshowersPolartwilight />,
		heavysnow: <Heavysnow />,
		heavysnowandthunder: <Heavysnowandthunder />,
		heavysnowshowersandthunder_day: <HeavysnowshowersandthunderDay />,
		heavysnowshowersandthunder_night: <HeavysnowshowersandthunderNight />,
		heavysnowshowersandthunder_polartwilight: <HeavysnowshowersandthunderPolartwilight />,
		heavysnowshowers_day: <HeavysnowshowersDay />,
		heavysnowshowers_night: <HeavysnowshowersNight />,
		heavysnowshowers_polartwilight: <HeavysnowshowersPolartwilight />,
		lightrain: <Lightrain />,
		lightrainandthunder: <Lightrainandthunder />,
		lightrainshowersandthunder_day: <LightrainshowersandthunderDay />,
		lightrainshowersandthunder_night: <LightrainshowersandthunderNight />,
		lightrainshowersandthunder_polartwilight: <LightrainshowersandthunderPolartwilight />,
		lightrainshowers_day: <LightrainshowersDay />,
		lightrainshowers_night: <LightrainshowersNight />,
		lightrainshowers_polartwilight: <LightrainshowersPolartwilight />,
		lightsleet: <Lightsleet />,
		lightsleetandthunder: <Lightsleetandthunder />,
		lightsleetshowers_day: <LightsleetshowersDay />,
		lightsleetshowers_night: <LightsleetshowersNight />,
		lightsleetshowers_polartwilight: <LightsleetshowersPolartwilight />,
		lightsnow: <Lightsnow />,
		lightsnowandthunder: <Lightsnowandthunder />,
		lightsnowshowers_day: <LightsnowshowersDay />,
		lightsnowshowers_night: <LightsnowshowersNight />,
		lightsnowshowers_polartwilight: <LightsnowshowersPolartwilight />,
		lightssleetshowersandthunder_day: <LightssleetshowersandthunderDay />,
		lightssleetshowersandthunder_night: <LightssleetshowersandthunderNight />,
		lightssleetshowersandthunder_polartwilight: <LightssleetshowersandthunderPolartwilight />,
		lightssnowshowersandthunder_day: <LightssnowshowersandthunderDay />,
		lightssnowshowersandthunder_night: <LightssnowshowersandthunderNight />,
		lightssnowshowersandthunder_polartwilight: <LightssnowshowersandthunderPolartwilight />,
		partlycloudy_day: <PartlycloudyDay />,
		partlycloudy_night: <PartlycloudyNight />,
		partlycloudy_polartwilight: <PartlycloudyPolartwilight />,
		rain: <Rain />,
		rainandthunder: <Rainandthunder />,
		rainshowersandthunder_day: <RainshowersandthunderDay />,
		rainshowersandthunder_night: <RainshowersandthunderNight />,
		rainshowersandthunder_polartwilight: <RainshowersandthunderPolartwilight />,
		rainshowers_day: <RainshowersDay />,
		rainshowers_night: <RainshowersNight />,
		rainshowers_polartwilight: <RainshowersPolartwilight />,
		sleet: <Sleet />,
		sleetandthunder: <Sleetandthunder />,
		sleetshowersandthunder_day: <SleetshowersandthunderDay />,
		sleetshowersandthunder_night: <SleetshowersandthunderNight />,
		sleetshowersandthunder_polartwilight: <SleetshowersandthunderPolartwilight />,
		sleetshowers_day: <SleetshowersDay />,
		sleetshowers_night: <SleetshowersNight />,
		sleetshowers_polartwilight: <SleetshowersPolartwilight />,
		snow: <Snow />,
		snowandthunder: <Snowandthunder />,
		snowshowersandthunder_day: <SnowshowersandthunderDay />,
		snowshowersandthunder_night: <SnowshowersandthunderNight />,
		snowshowersandthunder_polartwilight: <SnowshowersandthunderPolartwilight />,
		snowshowers_day: <SnowshowersDay />,
		snowshowers_night: <SnowshowersNight />,
		snowshowers_polartwilight: <SnowshowersPolartwilight />,
	},
];

export default WeatherSVGData;